/**
 * in this module there are all the related functions for:
 *  - initialize the layer
 *  - add the layer to the map
 *  - initialize the datepicker
 */
/**
 * import modules
 */
import TileLayer from 'ol/layer/Tile'
import TileWMS from 'ol/source/TileWMS'
import TileGrid from 'ol/tilegrid/TileGrid'
import functions from '../common/functions'
import map from '../common/map'
import layers from './pmlayers'
/**
 * global vars
 */

let pcfeatlayer
let sQLayers
var pageconfig = JSON.parse($('#pageconfig').val())
//let layerinfo = pageconfig.layers.find(el => el.layers === "consult")
//this wont work on ie11 so need to use function below

var layerinfo = functions.altFind(pageconfig.layers, function(e) {
return e.layers === "consult"
})
/**
 * create the parkmap layer
 */

let initPcLayer = () => {
  /**
   * check app is consult
   * otherwise return - no need to initialise
   */
    if (pageconfig.appname.type !== 'consult') {
        return;
    }
  /**
   * get resolutions from scale
   */

  // final resolutions array
  const resolutions = []
  // temp scale array
  const scaleArray = []
  // scales array
  const scales = pageconfig.scales.split(',')
  // create a temporary array of scales in number
  functions.getScale(scales, scaleArray)
  // create the final resolutions array
  functions.setResolution(scaleArray, resolutions)

  /**
  * get the extent of the visible map
   */

  const setExt = pageconfig.bounds.split(',')
  const ext = [parseInt(setExt[0]), parseInt(setExt[1]), parseInt(setExt[2]), parseInt(setExt[3])]

  /**
   * set the correct sqlayers
   */

    // default to proposed layers
    sQLayers = functions.getLayerList(pageconfig.appname.type)
    $('#option_proposed').val(sQLayers)
    $('#option_existing').val(functions.getLayerList('parkmap'))
    $('#option_all').val(functions.getLayerList('consultgrey') + ',' + sQLayers)
    if ($('#streetlight').prop('checked')) {
        sQLayers = 'streetlight,' + sQLayers
    }
    if ($('#strategiclayer').prop('checked')) {
        sQLayers = 'strategiclayer,' + sQLayers
    }
  /**
   * get the current date
   * set the default date to display the restrictions
   */

  const today = new Date()
  let sDTo = `${today.getFullYear()}-${functions.leadZero(today.getMonth() + 1)}-${functions.leadZero(today.getDate())}`

  /**
   * initialize suspid
   * get the url parameters
   */

  // feature layer
  pcfeatlayer = new TileLayer({
    // this extent limit the visible map
    className: 'featlayer',
    name: 'consult',
    extent: ext,
    // Load low-resolution tiles up to preload levels. By default preload is 0, which means no preloading
    preload: Infinity,
    source: new TileWMS({
      url: layerinfo.wmsfeat,
      params: {
        'LAYERS': sQLayers,
        MYORDERS: $('#featclick').val(),
        DTO: sDTo,
        SCHEME: 0,
        format: 'image/png'
      },
      ratio: 1,
      gutter: 40,
      serverType: 'mapserver',
      crossOrigin: 'anonymous',
      projection: 'EPSG:27700',
      tileGrid: new TileGrid({
        resolutions: resolutions,
        extent: ext,
        tileSize: [128, 128]
      })
    })
  })

  /**  Remove the confirmed order layer
  * already initialised before PC layers
  * in traffweb.js
  */
  map.getMap().removeLayer(layers.pmlayer())

  /**
   * end let initPmLayer = () => {
   */
}



/**
 * update the parkmap layer parameters
 */

const updateLayerScheme = (schemeid) => {
/**
 * hide the layer
 */
//check for accident layers otherwise return
if (functions.getLayerList('consult') === '') {return}

pcfeatlayer.setVisible(false)

/**
 * update the restrictions to dipslay
 * update the date
 * refresh the source
 * show the layer
 */

pcfeatlayer.getSource().getParams().SCHEME = schemeid
pcfeatlayer.getSource().refresh()
pcfeatlayer.setVisible(true)

map.getMapTab()
/**
 * end const updateLayerScheme = (schemeid) => {
 */
}

/**
 * change public consultation layer
 */

const changePCLayer = (theLayer) => {
  /**
   *
   * update the layer vars accordingly
   */
  let sQLayers
  /**
   * get the layer from the map and remoe it
   */
  map.getMap().removeLayer(pcfeatlayer)
  map.getMap().removeLayer(layers.pmlayer())
  /**
   * update the layer depending on which layer you select in the select element
   */
  let schemeid =parseInt($('#currentscheme').val())
  let extraLayers = ""

  if ($('#streetlight').prop('checked')) {
    extraLayers = 'streetlight,'
  }
  if ($('#strategiclayer').prop('checked')) {
    extraLayers += 'strategiclayer,'
  }

  sQLayers = extraLayers + theLayer

  if ($("#select_layers option:selected").attr('id') === "option_existing") {
    //show exisitng layers
    map.getMap().addLayer(layers.pmlayer())
    $('#consult_list').css('display','none')
    $('#existing_list').css('display','block')
    return
  }
  /**
   * update the layer parameters
   */
  $('#consult_list').css('display','block')
  $('#existing_list').css('display','none')
  let sDTo = new Date()
  sDTo = `${sDTo.getFullYear()}-${sDTo.getMonth() + 1}-${sDTo.getDate()}`

  pcfeatlayer = new TileLayer({
    source: new TileWMS({
      url: layerinfo.wmsfeat,
      params: {'LAYERS': sQLayers, MYORDERS: $('#featclick').val(), DTO: sDTo, format: 'image/png', SCHEME: schemeid},
      ratio: 1,
      gutter: 40,
      serverType: 'mapserver',
      crossOrigin: 'anonymous',
      projection: 'EPSG:27700'
    })
  })

  /**
   * refresh the layer's source
   * add the layer
   * remove the singleclick event to prevent multiples triggers
   * intialize the popup again
   */

  pcfeatlayer.getSource().refresh()
  map.getMap().addLayer(pcfeatlayer)
  pcfeatlayer.setZIndex(6)
  map.getMapTab()

/**
 * end const changePCLayer = (theLayer) => {
 */
}

/**
 * export the layers
 */

const pclayer = () => {
  return pcfeatlayer
}

const sQLayer = () => {
  return sQLayers
}

/**
 * export the addlayer
 */

const addlayer = () => {
  if (pageconfig.appname.type !== 'consult') {
    // app check
    return;
  }
  map.getMap().addLayer(pcfeatlayer)
  pcfeatlayer.setZIndex(2)
}

/**
 * EXPORT
 */

export default {
  changePCLayer,
  updateLayerScheme,
  addlayer,
  pclayer,
  sQLayer,
  initPcLayer
}
